<template>
    <div class="member-group-container">
        <div class="left-grouop" v-loading="isGroupLoading">
            <div class="group-item" :class="leftGroupActive === -1 ? 'actived' : ''" @click="leftGroupActive = -1">
                <p class="name">全部会员</p>
                <p class="num">{{allMembersNum}}</p>
                <group-popper mode="addGroup" :groupNum="groupList.length"  @groupSuccess="groupSuccess" class="group-popper" />
            </div>
            <Drop
                tag="div"
                v-for="(item, index) in groupList"
                class="group-item" 
                :class="leftGroupActive === item.id ? 'actived' : ''"
                @drop="leftDrag"
                @dragenter="onDragEnter"
                @dragleave="onDragLeave"
                @click.native="leftGroupActive = item.id"
                :key="index">
                    <div class="drap">{{item.id}}</div>
                    <img v-if="item.is_default" src="~@/assets/images/default_member_group.svg" />
                    <p class="name">{{item.name}}</p>
                    <p class="num">{{item.member_count}}</p>
                    <group-popper class="group-popper" @groupSuccess="groupSuccess" mode="editGroup" :groupInfo="item" />
            </Drop>
        </div>
        <drag class="right-list" :draggable="!!selectedMembers.length" :transfer-data="selectedMembers">
            <el-checkbox-group v-model="selectedMembers" style="height:calc(100% - 50px)">
            <el-table
                v-loading="isLoading"
                :data="memberList"
                v-textHighlight="{
                    keyword: keyword,
                    indexs: [1],
                    isBegin: !isLoading
                }"
                height="100%"
                ref="table"
                :empty-text="isLoading ? ' ' : '暂无数据'"
                @sort-change="sortChange">
                <el-table-column fixed width="40">
                    <template v-slot="{ row }">
                        <el-checkbox :label="row.id"></el-checkbox>
                    </template>
                </el-table-column>
                <el-table-column fixed type="index" width="70" />
                <el-table-column
                    fixed
                    label="会员昵称" 
                    min-width="180">
                    <template v-slot="{ row }">
                        <user-info v-if="row.user" :userInfo="{
                            avatar: row.user.avatar,
                            nickname: row.user.nickname,
                            realname: row.name,
                            gender: row.user.gender
                        }" />
                    </template>
                </el-table-column>
                <el-table-column 
                    min-width="110">
                    <template slot="header">
                        <span>会员分组 </span>
                        <i class="el-icon el-icon-arrow-down"></i>
                    </template>
                    <template v-slot="{ row }">
                        <span class="text-popper" v-textPopper>{{ row.group.name }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="birthday" label="生日" min-width="110" sortable="custom"/>
                <el-table-column prop="balance" label="会员余额(元)" min-width="160" align="right" sortable="custom">
                    <template v-slot="{ row }">
                        <span class="pr-24 text-popper" v-textPopper v-numberAlign>{{ row.balance }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="accumulated_recharge" label="累计充值(元)" min-width="160" align="right">
                    <template v-slot="{ row }">
                        <span class="text-popper" v-textPopper>{{ row.accumulated_recharge }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="accumulated_consume" label="累计消费(元)" min-width="160" align="right">
                    <template v-slot="{ row }">
                        <span class="text-popper" v-textPopper>{{ row.accumulated_consume }}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="accumulated_consume_count" label="累计消费次数" min-width="160" align="right">
                    <template v-slot="{ row }">
                        <span class="text-popper" v-textPopper>{{ row.accumulated_consume_count }}</span>
                    </template>
                </el-table-column>
                <el-table-column min-width="20"/>
                <el-table-column fixed="right" label="操作" width="80">
                    <template v-slot="{ row }">
                        <div class="operate fx-v-center">
                            <button class="text-btn" @click="$router.push({
                                path: '/main/member/memberDetail',
                                query: {
                                    id: row.id
                                }
                            })">详情</button>
                        </div>
                    </template>
                </el-table-column>
                <p v-if="isHasMore && isScrollLoading" slot="append" style="text-align: center; padding: 10px;">
                    <span class="loading-step-animation">正在加载...</span>
                </p>
                <p v-if="(!isHasMore) && memberList.length > 0" slot="append" style="text-align: center; padding: 10px;">没有更多了</p>
            </el-table>
            </el-checkbox-group>
            <div class="seleted-num">
                 <el-checkbox 
                    :indeterminate="isIndeterminate"
                    v-model="isSelectAll">
                    已选{{ selectedMembers.length }}个会员
                </el-checkbox>
            </div>
            <div slot="image">
                <DragImage :membersList="getSelectGoods()"></DragImage>
            </div>
        </drag>
        <make-group ref="makeGroup" @sureAddMember="sureAddMember"></make-group>
    </div>
</template>

<script lang="tsx">
import { ref, createComponent, SetupContext, computed, watch, onBeforeMount, onMounted } from '@vue/composition-api'
import { Drag, Drop } from 'vue-drag-drop'
import Draggable from 'vuedraggable/src/vuedraggable.js'
import DragImage from './DragImage.vue'
import GroupPopper from './group_popper.vue'
import { setObjectItemToFixed } from '@/utils/index'
import $fetch from '@/api'
import { openMessage, useScrollLoad } from '@/utils/system.tsx'
import MakeGroup from './make_group.vue'

export default createComponent({
    setup(props, ctx: SetupContext) {
        const keyword = ref<string>('')
        const groupList = ref<any[]>([])
        const allMembersNum = ref<number>(0)
        const leftGroupActive = ref<number>(-1)
        const isGroupLoading = ref<boolean>(true)

        const oOrderBy = ref<number | undefined>()
        const oOrderMethod = ref<number | undefined>()
        const memberList = ref<any[]>([])
        const selectedMembers = ref<any[]>([])
        const isLoading = ref<boolean>(true)

        const {
            page: oPage,
            isHasMore,
            isLoading: isScrollLoading,
            bindListener,
            initScrollLoad
        } = useScrollLoad()

        const orderByMap = {
            birthday: 'birthday',
            balance: 'balance',
            accumulated_recharge: 'accumulated_recharge',
            accumulated_consume: 'accumulated_consume',
            accumulated_consume_count: 'accumulated_consume_count'
        }

        const orderMethedMap = {
            null: undefined,
            descending: false,
            ascending: true
        }

        const isSelectAll = computed({
            get: () => {
                return selectedMembers.value.length === memberList.value.length && memberList.value.length > 0
            },
            set: (val) => {
                if (val) {
                    selectedMembers.value = memberList.value.map(value => value.id)
                } else {
                    selectedMembers.value = []
                }
            }
        })

        const isIndeterminate = computed(() => memberList.value.length !== selectedMembers.value.length && !!selectedMembers.value.length)

        watch(leftGroupActive, () => {
            isSelectAll.value = false
            oPage.value = 1
            getMemberList()
        })

        onBeforeMount(() => {
            getGroups()
            getMemberList()
        })

        onMounted(() => {
            bindListener({
                dom: (ctx.refs.table as any).$el.querySelector('.el-table__body-wrapper'),
                loadFunction: getMemberList
            })
        })

        function setKeyword(value: string) {
            keyword.value = value
            oPage.value = 1
            getMemberList()
        }

        function onDragEnter(_, event) {
            event.target.style.border = '1px solid #ee5b5b'
        }

        function onDragLeave(_, event) {
            event.target.style.border = ''
        }

        function leftDrag(seleted, event) {
            const idDom = event.target.firstChild
            event.target.style.border = ''
            if (Number((idDom as any).innerHTML) === leftGroupActive.value) {
                return
            }
            (ctx.refs.makeGroup as any).open({
                mode: 'addMember',
                groupInfo: groupList.value.filter(item => item.id === Number((idDom as any).innerHTML))[0],
                seletedNum: selectedMembers.value.length
            })
        }

        function getGroups() {
            isGroupLoading.value = true
            return $fetch.post({
                url: '/membership/getmembergrouplist',
            }).then(data => {
                groupList.value = data
                sessionStorage.setItem('defaultMemberGroupName', data[0].name)
                allMembersNum.value = groupList.value.map(x => x.member_count).reduce((a, b) => a + b)
                isGroupLoading.value = false
            }).catch(e => {
                openMessage('error', e.message)
            })
        }

        function getMemberList(page: number = oPage.value) {
            isLoading.value = true
            return $fetch.post({
                url: '/membership/getmemberlist',
                params: {
                    page,
                    group_ids: leftGroupActive.value > -1 ? [leftGroupActive.value] : undefined,
                    order_by: oOrderBy.value,
                    desc: oOrderMethod.value,
                    keyword: keyword.value ? keyword.value : undefined,
                }
            }).then(data => {
                data = setObjectItemToFixed(data)
                if (isSelectAll.value) {
                    // 等memberList赋值完成，再设置改值
                    setTimeout(() => {
                        isSelectAll.value = true
                    }, 0)
                }
                if (page === 1) {
                    memberList.value = []
                    ctx.root.$nextTick(() => {
                        memberList.value = data.member_list
                        initScrollLoad(data)
                    })
                } else {
                    memberList.value = memberList.value.concat(data.member_list)
                }
                isLoading.value = false
                return data
            }).catch(e => openMessage('error', e.message || '获取会员列表失败'))
        }

        const sortChange = ({ column, prop, order }) => {
            oOrderMethod.value = orderMethedMap[order]
            oOrderBy.value = oOrderMethod.value == null ? undefined : orderByMap[prop]
            oPage.value = 1
            getMemberList()
        }

        function sureAddMember(data: {
            groupInfo: any,
            successCallback: () => void
        }) {
            $fetch.post({
                url: '/membership/changemembershipgroup',
                params: {
                    group_id: data.groupInfo.id,
                    membership_id_list: selectedMembers.value
                }
            }).then(() => {
                isSelectAll.value = false
                oPage.value = 1
                getGroups()
                getMemberList()
                data.successCallback()
                openMessage("success", "修改分组成功")
            }).catch(e => {
                openMessage('error', e.message || '设置分组失败！')
            })
        }

        function groupSuccess(mode: string) {
            if (mode === 'deteleGroup') {
                leftGroupActive.value = -1
            }
            isSelectAll.value = false
            oPage.value = 1
            getGroups()
            getMemberList()
        }

        function getSelectGoods() {
            return memberList.value.filter(value => {
                return selectedMembers.value.includes(value.id)
            })
        }

        return {
            keyword,
            groupList,
            memberList,
            allMembersNum,
            selectedMembers,
            isSelectAll,
            leftGroupActive,
            isIndeterminate,
            isHasMore,
            isScrollLoading,
            isGroupLoading,
            isLoading,

            setKeyword,
            sureAddMember,
            sortChange,
            groupSuccess,
            onDragEnter,
            onDragLeave,
            leftDrag,
            getSelectGoods
        }
    },

    components: {
        Drag,
        Drop,
        DragImage,
        GroupPopper,
        MakeGroup
    }
})
</script>

<style lang="scss" scoped>
::v-deep .el-table {
    margin-top: 0!important;

    .el-table__header-wrapper, .el-table__body-wrapper {
        border: none!important;
    }

    th {
        border-top: none!important;
        background: #fff;

        .cell {
            color: #999;
        }

        .el-checkbox {
            visibility: hidden;
        }
    }

    .el-table__append-gutter {
        height: 34px!important;
    }
}
.member-group-container {
    display: flex;
    margin-top: 12px;
    height: calc(100% - 10px);
    overflow: hidden;
    border: 1px solid #F2F2F2;
}
.left-grouop {
    height: 100%;
    width: 170px;
    border-right: 1px solid #F2F2F2;
    overflow-y: auto;

    .group-item {
        display: flex;
        position: relative;
        align-items:center;
        height: 56px;
        border-bottom: 1px solid #F2F2F2;
        padding: 8px 0 8px 30px;
        font-size: 14px;
        line-height: 20px;
        cursor: pointer;

        .drap {
            width: 0;
            height: 0;
            opacity: 0;
        }

        > img {
            position: absolute;
            top: 0;
            right: 0;
            width: 30px;
            height: 30px;
            pointer-events: none;
        }

        .name {
            max-width: 72px;
            pointer-events: none;
        }

        .num {
            flex: 1;
            padding-right: 12px;
            text-align: right;
            color: #999;
            font-size: 12px;
            pointer-events: none;
        }

        .group-popper {
            flex: 1;
            display: none;
            text-align: right;
            width: 24px;
            cursor: pointer;
        }

        &:hover {
            background: #F7F7F7;

            .num {
                display: none;
            }
            
            .group-popper {
                display: block;
            }
        }
    }

    .actived {
        color: #009688;
        font-weight: bold;
        background: rgba(0,150,136,0.10)!important;
    }
}
.right-list {
    flex: 1;
    position: relative;
    height: 100%;
    overflow: hidden;
}
.seleted-num {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    padding: 15px;
}
</style>